import {
  GET_PROGRESSNOTE_DETAILS,
  GET_PROGRESSNOTE_SETTING,
  GET_ADMIN_NOTES,
  GET_PROGRESSNOTES,
  REMOVE_NOTE,
  GET_ADMIN_PROGRESSNOTE_SETTING,
  GET_PROGRESSNOTE_DETAILS_STATUS,
  // GET_DEFAULT_PROGRESSNOTE,
} from "./constants";

const initSetting = {
  progress_note_setting: {},
  progress_note_details: [],
  progress_notes: [],
  admin_notes: [],
  status: false,
};

// eslint-disable-next-line import/prefer-default-export
export const progressNoteReducer = (state = initSetting, action = {}) => {
  switch (action.type) {
    case GET_PROGRESSNOTE_SETTING: {
      return {
        ...state,
        progress_note_setting: action.payload,
      };
    }
    case GET_ADMIN_PROGRESSNOTE_SETTING: {
      return {
        ...state,
        progress_note_admin_setting: action.payload,
      };
    }
    case GET_PROGRESSNOTE_DETAILS_STATUS: {
      return {
        ...state,
        status: action.payload,
      };
    }
    case GET_PROGRESSNOTE_DETAILS: {
      return {
        ...state,
        progress_note_details: action.payload?.data,
        total: action.payload.total,
        status: false,
      };
    }
    case GET_PROGRESSNOTES: {
      return {
        ...state,
        progress_notes: action.payload,
      };
    }
    case GET_ADMIN_NOTES: {
      return {
        ...state,
        admin_notes: action.payload,
      };
    }
    case REMOVE_NOTE: {
      const newNote = state.progress_note_details.filter((item) => item.id !== action.payload);
      return {
        ...state,
        progress_note_details: [...newNote],
      };
    }
    default:
      return state;
  }
};
